This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div
    class="draggable drag-2"
    :class="checker ? 'selected' : ''"
    @click="clicked"
  >
    <div class="ifElse">
      <!-- Block as shown in the instructions container -->
      <div class="preview">{{ getTranslation("if") }} <em>test</em></div>

      <!-- Block as shown in the PSD/IDE -->
      <div class="blockEntry spaceBefore hidden codeBlock parent">
        <div class="title">
          <p class="">{{ getTranslation("if") }}</p>
          <div class="blockEntry upperBorder condition"></div>
        </div>
        <div class="blockTitles">
          <p class="true">{{ getTranslation("true") }}</p>
          <p class="false">{{ getTranslation("false") }}</p>
        </div>

        <div class="blocks">
          <div class="blockEntry upperBorder nested branch"></div>
          <div class="blockEntry upperBorder nested branch"></div>
        </div>
        <div class="buttonsRight breakPoint">
          <div class="tooltip">
            <button class="button warning small hidden">
              <img
                src="@/assets/images/icons/Pause.svg"
                alt="Breakpoint icon"
              />
            </button>
            <div class="tooltipText left">
              <p>{{ $t("game.tooltips.removeBreakpoint") }}</p>
              <i></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import json from "@/psdLang/lang.json";
import { addExtra, checkUsedBlock } from "@/utils/Functions";

@Options({
  name: "if-else-block",
  props: {},
  data() {
    return {
      lang: null,
      json: json,
    };
  },
  beforeMount() {
    this.lang = this.$store.getters.getIDELanguage;
  },
  methods: {
    /**
     * Get translation of item
     * @param s String to be translated
     */
    getTranslation(s: string) {
      return this.json[this.lang][s];
    },
    clicked() {
      addExtra("ifElse");
    },
  },
  computed: {
    checker() {
      return checkUsedBlock("ifElse");
    },
  },
})
export default class IfElse extends Vue {}
</script>
